import { render, staticRenderFns } from "./NewSemester.vue?vue&type=template&id=48c9d818&scoped=true&"
import script from "./NewSemester.vue?vue&type=script&lang=js&"
export * from "./NewSemester.vue?vue&type=script&lang=js&"
import style0 from "./NewSemester.vue?vue&type=style&index=0&id=48c9d818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9d818",
  null
  
)

export default component.exports